import InstallTile from './install-tile';

export default InstallTile;
